import React, { useEffect } from "react";
import CustomModal from "components/CustomModal";
import { Typography, Box } from "@material-ui/core";
import SortListReport from "./SortListReport";
import { useDispatch } from "react-redux";
import * as actions from "../controllers/actions";
import { useTranslation } from "react-i18next";

const ReportOrder = ({ open, setOpen, projectId }) => {
  const { t } = useTranslation();
  return (
    <CustomModal
      open={open}
      setOpen={setOpen}
      title={t("views.report_page.TITLE_SORT_REPORT")}
      maxWidth="lg"
    >
      <Box mt={1}>
        <Typography>{t("views.report_page.DES_SORT_REPORT")}</Typography>
        <SortListReport />
      </Box>
    </CustomModal>
  );
};

ReportOrder.propTypes = {};

export default ReportOrder;
